import { render, staticRenderFns } from "./OutletToMerchant.vue?vue&type=template&id=6788e1d8"
import script from "./OutletToMerchant.vue?vue&type=script&lang=js"
export * from "./OutletToMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports